import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}

.quality-dashboard {
  min-height: 100%;
  color: #202124;
  background: #f7f8f4;
}

.quality-shell {
  width: min(100%, 1500px);
  margin-inline: auto;
  padding-inline: 22px;
}

.quality-header {
  z-index: 12;
  background: #fff;
}

.quality-heading h1,
.quality-heading p {
  margin: 0;
}

.quality-heading p {
  margin-top: 7px;
  color: #777b82;
  font-size: 12px;
}

.quality-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.quality-range {
  height: auto;
  display: flex;
  align-items: center;
  gap: 9px;
  padding-inline: 0;
  border: 0;
  border-radius: 4px;
  background: #fff;
  color: #3e4147;
}

.quality-range select {
  min-width: 225px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #33363b;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.quality-primary {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  padding-inline: 17px;
  background: #e4572e;
  color: #fff;
}

.quality-primary:hover {
  background: #ca4824;
  color: #fff;
}

.quality-icon-button {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 0;
  background: transparent;
  color: #45484e;
}

.quality-icon-button:hover {
  background: #f0f1f2;
  color: #202124;
}

.quality-icon-a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  min-height: 44px;
  min-width: 44px;
}

.quality-main {
  display: grid;
  row-gap: var(--ro-section-gap, 16px);
}

.quality-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.quality-metric {
  --metric-color: #347a46;
  --metric-soft: #edf6ef;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #dfe1e4;
  border-radius: 4px;
  background: #fff;
  overflow: visible;
}

.quality-metric.is-purple {
  --metric-color: #7251ad;
  --metric-soft: #f0ecf8;
}

.quality-metric.is-blue {
  --metric-color: #3e72b2;
  --metric-soft: #edf3fa;
}

.quality-metric.is-orange {
  --metric-color: #c65a25;
  --metric-soft: #fbefe9;
}

.quality-metric__icon {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--metric-soft);
  color: var(--metric-color);
  font-size: 18px;
}

.quality-metric p,
.quality-metric strong,
.quality-metric span {
  margin: 0;
}

.quality-metric__content {
  position: relative;
  min-width: 0;
}

.quality-metric__content > p {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #3c3f45;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}

.quality-help-button {
  width: 22px;
  height: 22px;
  display: inline-grid;
  flex: 0 0 22px;
  place-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #73777e;
  cursor: pointer;
}

.quality-help-button:hover,
.quality-help-button:focus-visible,
.quality-help-button[aria-expanded=true] {
  background: var(--metric-soft);
  color: var(--metric-color);
  outline: none;
}

.quality-metric__content > strong {
  display: block;
  margin-top: 0;
  color: var(--metric-color);
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
}

.quality-metric > div > span {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  flex-wrap: wrap;
  line-height: 18px;
  color: #319150;
  font-size: 12px;
}

.quality-metric > div > span.is-down {
  color: #e4572e;
}

.quality-metric > div > span.is-empty {
  color: #777b82;
}

.quality-metric span em {
  color: #85888e;
  font-style: normal;
}

.quality-metric span b {
  font-weight: 700;
}

.quality-help-popover {
  position: absolute;
  top: 29px;
  right: -10px;
  z-index: 30;
  width: min(260px, 100vw - 48px);
  padding: 13px 14px;
  border: 1px solid #d7dadd;
  border-radius: 5px;
  background: #fff;
  color: #4b4f55;
  box-shadow: 0 10px 30px rgba(22, 26, 31, 0.14);
}

.quality-help-popover::before {
  position: absolute;
  top: -6px;
  right: 16px;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  border-top: 1px solid #d7dadd;
  border-left: 1px solid #d7dadd;
  background: #fff;
  content: "";
}

.quality-help-popover strong {
  display: block;
  color: #25282d;
  font-size: 12px;
  font-weight: 700;
}

.quality-help-popover p {
  display: block;
  margin: 6px 0 0;
  color: #696d73;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.55;
}

.quality-insights,
.quality-lower {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1.95fr) minmax(310px, 0.95fr);
  gap: 14px;
}

.quality-lower {
  align-items: stretch;
}

.quality-panel {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dfe1e4;
  border-radius: 4px;
  background: #fff;
}

.quality-panel__header {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
}

.quality-panel__header h2,
.quality-panel__header p {
  margin: 0;
}

.quality-panel__header h2 {
  color: #292c31;
  font-size: 14px;
  font-weight: 700;
}

.quality-panel__header p {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.quality-panel__header > a,
.quality-panel footer a {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #e4572e;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.quality-chart-tabs {
  display: flex;
  gap: 16px;
}

.quality-chart-tabs button {
  position: relative;
  padding: 8px 2px;
  border: 0;
  background: transparent;
  color: #a0a3a9;
}

.quality-chart-tabs button.is-active {
  color: #292c31;
}

.quality-chart-tabs button.is-active::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: #e4572e;
  content: "";
}

.quality-legend {
  display: flex;
  gap: 20px;
  padding: 0 18px 4px;
  color: #6f7278;
  font-size: 12px;
  font-weight: 700;
}

.quality-legend span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.quality-legend i {
  width: 18px;
  height: 2px;
  display: inline-block;
  background: #279248;
}

.quality-legend i.is-kg {
  background: #6f4db4;
}

.quality-legend i.is-qa-volume,
.quality-legend i.is-kg-volume {
  height: 2px;
  background: #279248;
  opacity: 0.55;
}

.quality-legend i.is-kg-volume {
  background: #6f4db4;
}

.quality-chart {
  min-height: 286px;
  padding: 0 14px 4px 4px;
}

.quality-chart canvas {
  display: block;
  max-width: 100%;
}

.quality-risk__body {
  display: grid;
  grid-template-columns: minmax(150px, 0.9fr) minmax(145px, 1fr);
  align-items: center;
  gap: 8px;
  padding: 0 14px 12px;
}

.quality-donut {
  position: relative;
  width: min(100%, 220px);
  aspect-ratio: 1/1;
  display: grid;
  place-items: center;
  justify-self: center;
}

.quality-donut canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
  aspect-ratio: 1/1;
}

.quality-donut__label {
  position: absolute;
  inset: 50% auto auto 50%;
  display: grid;
  justify-items: center;
  transform: translate(-50%, -50%);
  color: #4a4d53;
  pointer-events: none;
}

.quality-donut__label span {
  font-size: 12px;
}

.quality-donut__label strong {
  margin-top: 3px;
  font-size: 14px;
}

.quality-risk__legend {
  display: grid;
  gap: 11px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.quality-risk__legend li {
  display: grid;
  grid-template-columns: 9px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 7px;
  color: #60636a;
  font-size: 12px;
}

.quality-risk__legend li i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.quality-risk__legend li strong {
  color: #35383d;
  font-weight: 700;
}

.quality-risk__legend li em {
  min-width: 38px;
  color: #8d9096;
  font-style: normal;
  text-align: right;
}

.quality-risk__note {
  min-height: 46px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 11px 17px;
  background: #fbf8f6;
  color: #696c72;
  box-shadow: inset 0 1px 0 #e9e2de;
  font-size: 12px;
}

.quality-risk__note i {
  color: #e4572e;
  font-size: 14px;
}

.quality-empty {
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 16px;
  color: #878b91;
  text-align: center;
}

.quality-empty i {
  margin-bottom: 5px;
  color: #a1a5ab;
  font-size: 22px;
}

.quality-empty strong {
  color: #44484e;
  font-size: 12px;
  font-weight: 700;
}

.quality-empty p {
  margin: 0;
  color: #8b8f95;
  font-size: 12px;
  line-height: 1.5;
}

.quality-empty--compact {
  min-height: 0;
}

.quality-projects .quality-panel__header,
.quality-activity .quality-panel__header {
  box-shadow: inset 0 -1px 0 #e3e5e8;
}

.quality-project-table table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.quality-project-table th,
.quality-project-table td {
  height: 44px;
  padding: 0 9px;
  text-align: left;
  vertical-align: middle;
}

.quality-project-table th {
  background: #f7f8f9;
  color: #6b6e74;
  font-size: 12px;
  font-weight: 700;
}

.quality-project-table th:nth-child(1) {
  width: 6%;
}

.quality-project-table th:nth-child(2) {
  width: 22%;
}

.quality-project-table th:nth-child(3) {
  width: 11%;
}

.quality-project-table th:nth-child(4) {
  width: 11%;
}

.quality-project-table th:nth-child(5) {
  width: 12%;
}

.quality-project-table th:nth-child(6) {
  width: 10%;
}

.quality-project-table th:nth-child(7) {
  width: 19%;
}

.quality-project-table th:nth-child(8) {
  width: 9%;
}

.quality-project-table td {
  color: #4f5258;
  box-shadow: inset 0 -1px 0 #eceef0;
  font-size: 12px;
}

.quality-project-table tbody tr:hover {
  background: #fafbfb;
}

.quality-project-table td strong {
  color: #31343a;
  font-size: 12px;
  font-weight: 700;
}

.quality-project-table td.is-danger {
  color: #e4572e;
  font-weight: 700;
}

.quality-project-table td.is-good,
.quality-delta.is-good {
  color: #2d8a49;
  font-weight: 700;
}

.quality-delta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #e4572e;
  font-weight: 700;
}

.quality-review-link {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding-inline: 10px;
  border-radius: 3px;
  background: #e4572e;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.quality-review-link:hover {
  background: #ca4824;
  color: #fff;
}

.quality-projects > footer,
.quality-activity > footer {
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 17px;
  color: #85888e;
  font-size: 12px;
}

.quality-activity ul {
  margin: 0;
  padding: 0 16px;
  list-style: none;
}

.quality-activity li {
  min-height: 60px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  box-shadow: inset 0 -1px 0 #eceef0;
}

.quality-activity li:last-child {
  box-shadow: none;
}

.quality-activity__icon {
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #63708a;
  font-size: 12px;
}

.quality-activity__icon.is-red {
  color: #dc4338;
  background: #fdf0ef;
}

.quality-activity__icon.is-green {
  color: #2d924d;
  background: #edf7f0;
}

.quality-activity__icon.is-purple {
  color: #7151ad;
  background: #f1edf8;
}

.quality-activity__icon.is-orange {
  color: #e87920;
  background: #fff3e9;
}

.quality-activity__icon.is-blue {
  color: #4e78b4;
  background: #eef3fa;
}

.quality-activity li a {
  min-width: 0;
}

.quality-activity li strong,
.quality-activity li p {
  display: block;
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quality-activity li strong {
  color: #36393f;
  font-size: 12px;
  font-weight: 700;
}

.quality-activity li p {
  margin-top: 3px;
  color: #92959b;
  font-size: 12px;
}

.quality-activity time {
  color: #9a9da3;
  font-size: 12px;
  white-space: nowrap;
}

.quality-activity footer {
  justify-content: flex-end;
  box-shadow: inset 0 1px 0 #e3e5e8;
}

@media (max-width: 1180px) {
  .quality-insights,
  .quality-lower {
    grid-template-columns: 1fr;
  }
  .quality-risk__body {
    grid-template-columns: minmax(180px, 260px) minmax(0, 1fr);
  }
  .quality-activity ul {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0 18px;
  }
}
@media (max-width: 900px) {
  .quality-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .quality-project-table th:nth-child(5),
  .quality-project-table td:nth-child(5),
  .quality-project-table th:nth-child(6),
  .quality-project-table td:nth-child(6),
  .quality-project-table th:nth-child(7),
  .quality-project-table td:nth-child(7) {
    display: none;
  }
  .quality-project-table th:nth-child(1) {
    width: 8%;
  }
  .quality-project-table th:nth-child(2) {
    width: 32%;
  }
  .quality-project-table th:nth-child(3) {
    width: 18%;
  }
  .quality-project-table th:nth-child(4) {
    width: 18%;
  }
  .quality-project-table th:nth-child(8) {
    width: 24%;
  }
}
@media (max-width: 680px) {
  .quality-shell {
    padding-inline: 14px;
  }
  .quality-header__actions {
    min-width: 0;
  }
  .quality-range {
    min-width: 0;
    flex: 1;
  }
  .quality-range select {
    min-width: 0;
    width: 100%;
  }
  .quality-icon-button {
    display: none;
  }
  .quality-metrics {
    grid-template-columns: 1fr;
  }
  .quality-metric {
    min-height: 102px;
  }
  .quality-risk__body {
    grid-template-columns: 1fr;
  }
  .quality-project-mobile article {
    padding: 15px;
    box-shadow: inset 0 -1px 0 #eceef0;
  }
  .quality-project-mobile header {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }
  .quality-project-mobile header > span {
    color: #e4572e;
    font-weight: 700;
  }
  .quality-project-mobile h3,
  .quality-project-mobile p {
    margin: 0;
  }
  .quality-project-mobile header strong {
    color: #32353b;
    font-size: 12px;
  }
  .quality-project-mobile header p {
    margin-top: 4px;
    color: #8f9298;
    font-size: 12px;
  }
  .quality-project-mobile dl {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-block: 13px;
  }
  .quality-project-mobile dl div {
    display: grid;
    gap: 3px;
  }
  .quality-project-mobile dt {
    color: #999ca2;
    font-size: 12px;
  }
  .quality-project-mobile dd {
    margin: 0;
    color: #3e4147;
    font-size: 12px;
    font-weight: 700;
  }
  .quality-activity ul {
    grid-template-columns: 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  * {
    scroll-behavior: auto !important;
  }
}
/* Unified operations header ------------------------------------------------ */
.quality-header .quality-header__inner {
  box-sizing: border-box;
}

.quality-heading {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.quality-heading .quality-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  margin: 0;
  color: #df5935;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
  line-height: 1.2;
}

.quality-heading .quality-eyebrow i {
  font-size: 12px;
}

.quality-heading .reviewops-page-title {
  margin: 0;
}

.quality-heading > p:last-child {
  margin: 0;
  color: #6d746d;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.quality-header__actions {
  align-self: center;
  gap: 8px;
  margin-left: auto;
  flex: 0 0 auto;
}

.quality-range,
.quality-primary {
  min-height: 42px;
  border-radius: 9px;
  box-sizing: border-box;
}

.quality-primary {
  padding: 0 19px;
}

.quality-icon-button {
  width: 42px;
  height: 42px;
  border: 1px solid #d8dbe0;
  background: #fff;
}

@media (max-width: 639px) {
  .quality-header__actions {
    width: 100%;
    align-self: stretch;
    flex-wrap: wrap;
    margin-left: 0;
  }
  .quality-range {
    flex: 1 0 auto;
    max-width: 100%;
  }
  .quality-range select {
    min-width: 0;
    width: 100%;
  }
}
/* Brighter dashboard surfaces --------------------------------------------- */
.quality-dashboard {
  --review-surface: #ffffff;
  --review-surface-soft: #fbfcfa;
}

.quality-dashboard .quality-metrics,
.quality-dashboard .quality-panel,
.quality-dashboard .quality-metrics > .quality-metric,
.quality-dashboard .quality-panel__header,
.quality-dashboard .quality-projects > footer,
.quality-dashboard .quality-activity > footer {
  background: #ffffff !important;
}

.quality-dashboard .quality-metrics,
.quality-dashboard .quality-panel {
  border-color: #e3e7e1 !important;
}

.quality-data-notice {
  align-items: center;
  background: #eef5ff;
  border: 1px solid #abc8ec;
  border-radius: 6px;
  color: #244f7f;
  display: flex;
  gap: 10px;
  margin: 0;
  padding: 12px 14px;
  font-size: 12px;
  line-height: 1.5;
}

.quality-data-notice > i {
  color: #3778b9;
}

.quality-data-notice strong {
  margin-right: 8px;
  color: #173f6b;
}

/* Keep the KPI row on one border system: one frame and one divider per cell. */
:host-context(.reviewops-shell) .quality-dashboard .quality-metrics {
  gap: 0 !important;
  border: 1px solid #dfe5df !important;
  border-radius: 12px !important;
  outline: 0 !important;
  overflow: visible;
  background: #fff !important;
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .quality-dashboard .quality-metrics > .quality-metric {
  padding: 12px 16px;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

/* Panels own one padding layer; empty charts follow their content height. */
:host-context(.reviewops-shell) .quality-dashboard .quality-panel {
  padding: 0;
}
:host-context(.reviewops-shell) .quality-dashboard .quality-panel__header {
  min-height: 0;
  padding: 12px 16px;
  flex-wrap: wrap;
  gap: 8px 12px;
}
:host-context(.reviewops-shell) .quality-dashboard .quality-empty {
  color: var(--ro-muted);
  word-break: keep-all;
  overflow-wrap: anywhere;
}
:host-context(.reviewops-shell) .quality-dashboard .quality-empty strong {
  font-size: 14px;
  line-height: 22px;
}
:host-context(.reviewops-shell) .quality-dashboard .quality-empty p, :host-context(.reviewops-shell) .quality-dashboard .quality-panel__header p {
  color: var(--ro-muted);
  font-size: 14px;
  line-height: 22px;
}

:host-context(.reviewops-shell) .quality-dashboard .quality-metrics > .quality-metric + .quality-metric {
  border-left: 1px solid #dfe5df !important;
}

@media (min-width: 1024px) {
  :host-context(.reviewops-shell) .quality-dashboard .quality-metrics > .quality-metric:first-child {
    border-radius: 11px 0 0 11px !important;
  }
  :host-context(.reviewops-shell) .quality-dashboard .quality-metrics > .quality-metric:last-child {
    border-radius: 0 11px 11px 0 !important;
  }
  :host-context(.reviewops-shell) .quality-dashboard .quality-metrics > .quality-metric:only-child {
    border-radius: 11px !important;
  }
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .quality-dashboard .quality-metrics {
    gap: 12px !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
  }
  :host-context(.reviewops-shell) .quality-dashboard .quality-metrics > .quality-metric,
  :host-context(.reviewops-shell) .quality-dashboard .quality-metrics > .quality-metric + .quality-metric {
    border: 1px solid #dfe5df !important;
    border-radius: 9px !important;
  }
}`],
})
export class PageDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
    public selectedRange: string = '';
    public ranges: string[] = [];
    public chartMode: string = '통과율';
    public activeMetricHelp: string = '';
    public metrics: any[] = [];
    public riskFactors: any[] = [];
    public projects: any[] = [];
    public activities: any[] = [];
    public hasTrendData: boolean = false;
    public hasRiskData: boolean = false;
    public rangeDescription: string = '';
    public uiLoading: boolean = true;
    public loadError: string = '';
    public projectTotal: number = 0;
    public delegatedAiRecordCount: number = 0;
    public humanReleasePendingCount: number = 0;
    private weekLabels: string[] = [];
    private qaPass: Array<number | null> = [];
    private kgPass: Array<number | null> = [];
    private qaVolume: number[] = [];
    private kgVolume: number[] = [];
    private dashboardRecords: any[] = [];
    private workspaceState: any = {};
    private rangeWindows: any = {};
    private readonly issueMeta: any = {
        FACT_ERROR: { label: '사실 오류', color: '#e54839' },
        EVIDENCE_GAP: { label: '근거 부족', color: '#ef7d22' },
        CONTEXT_GAP: { label: '맥락 누락', color: '#f2b62f' },
        LABEL_MISMATCH: { label: '유형·관계 오류', color: '#5f86bd' },
        DUPLICATE: { label: '중복', color: '#8a74aa' },
        EXPRESSION: { label: '표현 개선', color: '#c8cbd0' }
    };
    private resizeHandler = () => this.scheduleCharts();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        this.initializeRanges();
        await this.loadDashboardData();
        this.uiLoading = false;
        await this.service.render();
        this.scheduleCharts();
    }

    public ngAfterViewInit() {
        if (typeof window !== 'undefined') window.addEventListener('resize', this.resizeHandler);
        this.scheduleCharts();
    }

    public ngOnDestroy() {
        if (typeof window !== 'undefined') window.removeEventListener('resize', this.resizeHandler);
    }

    public async changeRange(range: string) {
        this.selectedRange = range;
        this.rebuildDashboard();
        await this.service.render();
        this.scheduleCharts();
    }

    public async setChartMode(mode: string) {
        this.chartMode = mode;
        await this.service.render();
        this.scheduleCharts();
    }

    public metricToneClass(tone: string) {
        return 'is-' + tone;
    }

    public toggleMetricHelp(metric: any) {
        this.activeMetricHelp = this.activeMetricHelp === metric.key ? '' : metric.key;
    }

    public closeMetricHelp() {
        this.activeMetricHelp = '';
    }

    public riskTotal() {
        return this.riskFactors.reduce((sum: number, item: any) => sum + Number(item.value || 0), 0);
    }

    public riskPercent(value: number) {
        const total = this.riskTotal();
        return total ? ((value / total) * 100).toFixed(1) : '0.0';
    }

    public riskNote() {
        if (!this.riskFactors.length) return '';
        const top = this.riskFactors.slice().sort((a: any, b: any) => b.value - a.value)[0];
        return '가장 많이 선택된 위험 요인은 ' + top.label + '입니다. 해당 검수 기준을 우선 확인해주세요.';
    }

    public absolute(value: number) {
        return Math.abs(value);
    }

    private initializeRanges() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const weekStart = new Date(today);
        const day = weekStart.getDay() || 7;
        weekStart.setDate(weekStart.getDate() - day + 1);
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekEnd.getDate() + 6);
        const previousStart = new Date(weekStart);
        previousStart.setDate(previousStart.getDate() - 7);
        const previousEnd = new Date(weekStart);
        previousEnd.setDate(previousEnd.getDate() - 1);
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);

        const currentWeek = this.rangeLabel(weekStart, weekEnd, '주간');
        const previousWeek = this.rangeLabel(previousStart, previousEnd, '주간');
        const currentMonth = this.rangeLabel(monthStart, today, '월간');
        this.rangeWindows[currentWeek] = { start: weekStart, end: this.endOfDay(weekEnd) };
        this.rangeWindows[previousWeek] = { start: previousStart, end: this.endOfDay(previousEnd) };
        this.rangeWindows[currentMonth] = { start: monthStart, end: this.endOfDay(today) };
        this.ranges = [currentWeek, previousWeek, currentMonth];
        this.selectedRange = currentWeek;
    }

    private rangeLabel(start: Date, end: Date, suffix: string) {
        return this.isoDate(start) + ' ~ ' + this.isoDate(end) + ' (' + suffix + ')';
    }

    private isoDate(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return [year, month, day].join('-');
    }

    private endOfDay(date: Date) {
        const result = new Date(date);
        result.setHours(23, 59, 59, 999);
        return result;
    }

    private async loadDashboardData() {
        try {
            const response = await fetch('/api/v1/review-workspace/state', {
                method: 'GET',
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
                cache: 'no-store'
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, '대시보드 데이터를 불러오지 못했습니다.'));
            const state = this.dashboardState(payload);
            if (!state) throw new Error('대시보드 응답 형식이 올바르지 않습니다.');
            this.workspaceState = state;
            this.dashboardRecords = this.serverDashboardRecords(state);
            this.loadError = '';
        } catch (error) {
            this.loadError = error instanceof Error
                ? error.message
                : '대시보드 데이터를 불러오지 못했습니다.';
            this.workspaceState = {};
            this.dashboardRecords = [];
        }
        this.rebuildDashboard();
    }

    private serverDashboardRecords(state: any) {
        const tasks: any = {};
        state.tasks.forEach((task: any) => {
            if (task && task.id) tasks[String(task.id)] = task;
        });
        const projectNames: any = {};
        (Array.isArray(state.projects) ? state.projects : []).forEach((project: any) => {
            const id = String(project && (project.id || project.projectId || project.project_id) || '');
            if (id) projectNames[id] = String(project.name || project.title || id);
        });

        return Object.keys(state.evaluations || {}).reduce((records: any[], taskId: string) => {
            const evaluation = state.evaluations[taskId] || {};
            const task = tasks[taskId] || {};
            const submittedAtValue = evaluation.submittedAt || evaluation.submitted_at || evaluation.recorded_at;
            if (!(evaluation.submitted === true || submittedAtValue) || !submittedAtValue) return records;
            const submittedAt = new Date(submittedAtValue);
            if (Number.isNaN(submittedAt.getTime())) return records;
            const kind = String(task.kind || (taskId.indexOf('KG-') === 0 ? 'kg' : taskId.indexOf('QA-') === 0 ? 'qa' : '')).toLowerCase();
            if (kind !== 'qa' && kind !== 'kg') return records;
            const projectId = String(task.projectId || task.project_id || this.projectIdFromTask(taskId));
            const projectName = typeof task.project === 'string' && task.project.trim()
                ? task.project
                : String(task.projectName || task.project_name || projectNames[projectId] || projectId);
            const score = this.evaluationScore(evaluation);
            const target = Number(task.target ?? evaluation.target) || 90;
            const reviewMode = String(
                task.review_mode || task.reviewMode
                || evaluation.review_mode || evaluation.reviewMode || ''
            ).trim().toLowerCase();
            const reviewerKind = String(
                task.reviewer_kind || task.reviewerKind
                || evaluation.reviewer_kind || evaluation.reviewerKind || ''
            ).trim().toLowerCase();
            const notHumanReview = task.not_human_review === true
                || task.notHumanReview === true
                || evaluation.not_human_review === true
                || evaluation.notHumanReview === true;
            const humanReleaseStatus = String(
                task.human_release_status || task.humanReleaseStatus
                || evaluation.human_release_status
                || evaluation.humanReleaseStatus || ''
            ).trim().toLowerCase();
            const delegatedAi = reviewMode === 'delegated_ai'
                || notHumanReview
                || reviewerKind === 'codex_delegated_ai_quality_reviewer';
            records.push({
                taskId: taskId,
                kind: kind,
                projectId: projectId,
                projectName: projectName,
                submittedAt: submittedAt,
                decision: evaluation.decision,
                score: score,
                target: target,
                passed: evaluation.decision === 'approve' && score !== null && score >= target,
                issues: Array.isArray(evaluation.issues) ? evaluation.issues : [],
                scores: evaluation.scores || {},
                durationMinutes: this.optionalNumber(evaluation.durationMinutes ?? evaluation.duration_minutes),
                reviewMode: reviewMode,
                reviewerKind: reviewerKind,
                notHumanReview: notHumanReview,
                delegatedAi: delegatedAi,
                humanReleaseStatus: humanReleaseStatus
            });
            return records;
        }, []);
    }

    private projectIdFromTask(taskId: string) {
        const projectMatch = taskId.match(/(?:QA|KG)-(RV-\d{4}-\d+)/);
        return projectMatch ? projectMatch[1] : taskId;
    }

    private evaluationScore(evaluation: any) {
        const explicit = this.optionalNumber(evaluation && evaluation.score);
        if (explicit !== null) return explicit;
        const scores = evaluation && evaluation.scores && typeof evaluation.scores === 'object'
            ? Object.keys(evaluation.scores).map((key: string) => Number(evaluation.scores[key])).filter((value: number) => value > 0)
            : [];
        if (!scores.length) return null;
        return scores.reduce((sum: number, value: number) => sum + value, 0) / scores.length * 20;
    }

    private optionalNumber(value: any) {
        if (value === null || value === undefined || value === '') return null;
        const number = Number(value);
        return Number.isFinite(number) ? number : null;
    }

    private async readResponse(response: Response) {
        try {
            return await response.json();
        } catch (error) {
            return {};
        }
    }

    private dashboardState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Array.isArray(candidate.tasks)
                || Array.isArray(candidate.projects)
                || candidate.evaluations && typeof candidate.evaluations === 'object'
            ));
        if (!state) return null;
        return Object.assign({}, state, {
            projects: Array.isArray(state.projects) ? state.projects : [],
            tasks: Array.isArray(state.tasks) ? state.tasks : [],
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private responseMessage(payload: any, fallback: string) {
        const data = payload && payload.data;
        const error = payload && payload.error;
        return String(payload && payload.message
            || data && data.message
            || error && (error.message || error)
            || fallback);
    }

    private rebuildDashboard() {
        const range = this.rangeWindows[this.selectedRange];
        if (!range) return;
        const records = this.dashboardRecords.filter((record: any) => {
            const time = record.submittedAt.getTime();
            return time >= range.start.getTime() && time <= range.end.getTime();
        });
        const duration = range.end.getTime() - range.start.getTime() + 1;
        const previousRange = {
            start: new Date(range.start.getTime() - duration),
            end: new Date(range.end.getTime() - duration)
        };
        const previous = this.dashboardRecords.filter((record: any) => {
            const time = record.submittedAt.getTime();
            return time >= previousRange.start.getTime() && time <= previousRange.end.getTime();
        });

        this.rangeDescription = this.isoDate(range.start) + '부터 ' + this.isoDate(range.end)
            + '까지 실제 제출된 검수 결과입니다.';
        this.delegatedAiRecordCount = records.filter(
            (record: any) => record.delegatedAi === true
        ).length;
        this.humanReleasePendingCount = records.filter(
            (record: any) => record.delegatedAi === true
                && record.humanReleaseStatus === 'pending'
        ).length;
        this.metrics = [
            this.buildRateMetric('qa', 'QA 통과율', 'green', 'fa-shield-halved', records, previous),
            this.buildRateMetric('kg', 'KG 통과율', 'purple', 'fa-shield', records, previous),
            this.buildVolumeMetric(records, previous),
            this.buildTimeMetric(records, previous)
        ];
        this.buildTrend(records, range);
        this.buildRisks(records);
        this.buildProjects(records);
        this.buildActivities(records);
    }

    private buildRateMetric(kind: string, label: string, tone: string, icon: string, records: any[], previous: any[]) {
        const current = records.filter((record: any) => record.kind === kind);
        const before = previous.filter((record: any) => record.kind === kind);
        const rate = this.passRate(current);
        const oldRate = this.passRate(before);
        const delta = rate === null || oldRate === null ? null : rate - oldRate;
        const aiRows = current.filter((record: any) => record.delegatedAi === true);
        const pendingRows = aiRows.filter(
            (record: any) => record.humanReleaseStatus === 'pending'
        );
        const metricLabel = aiRows.length
            ? kind.toUpperCase() + (
                aiRows.length === current.length
                    ? ' AI 품질 통과율'
                    : ' 품질 통과율 (AI·사람)'
            )
            : label;
        const help = aiRows.length
            ? metricLabel + '은 위임형 AI 검수의 품질 gate 통과를 포함합니다. '
                + '사람 release와는 별도이며 현재 사람 release 대기 '
                + pendingRows.length + '건입니다.'
            : label + '은 선택 기간에 제출된 ' + kind.toUpperCase()
                + ' 종합 검수 중 ‘사용 가능’ 판정과 작업 목표 점수를 모두 충족한 비율입니다.';
        return {
            key: kind + '-rate', label: metricLabel, value: rate === null ? '—' : rate.toFixed(1) + '%',
            delta: this.deltaText(delta, '%p'), direction: delta !== null && delta < 0 ? 'down' : 'up', tone: tone, icon: icon,
            help: help,
            hasData: rate !== null
        };
    }

    private buildVolumeMetric(records: any[], previous: any[]) {
        const delta = records.length - previous.length;
        return {
            key: 'volume', label: '처리량', value: records.length ? records.length.toLocaleString() + '건' : '—',
            delta: previous.length || records.length ? this.deltaText(delta, '건') : '비교 데이터 없음',
            direction: delta < 0 ? 'down' : 'up', tone: 'blue', icon: 'fa-table-list', hasData: records.length > 0,
            help: '처리량은 선택 기간에 최종 제출된 QA·KG 종합 검수 작업 수입니다.'
        };
    }

    private buildTimeMetric(records: any[], previous: any[]) {
        const currentTimes = records.map((record: any) => record.durationMinutes).filter((value: any) => value !== null);
        const previousTimes = previous.map((record: any) => record.durationMinutes).filter((value: any) => value !== null);
        const average = this.average(currentTimes);
        const oldAverage = this.average(previousTimes);
        const delta = average === null || oldAverage === null ? null : average - oldAverage;
        return {
            key: 'average-time', label: '평균 검수 시간', value: average === null ? '—' : average.toFixed(1) + '분',
            delta: average === null ? '측정 데이터 없음' : this.deltaText(delta, '분'),
            direction: delta !== null && delta > 0 ? 'down' : 'up', tone: 'orange', icon: 'fa-clock', hasData: average !== null,
            help: '평균 검수 시간은 시작·제출 시각이 함께 기록된 완료 작업의 평균 소요 시간입니다.'
        };
    }

    private passRate(records: any[]) {
        if (!records.length) return null;
        const passed = records.filter((record: any) => record.passed === true).length;
        return passed / records.length * 100;
    }

    private average(values: number[]) {
        if (!values.length) return null;
        return values.reduce((sum: number, value: number) => sum + value, 0) / values.length;
    }

    private deltaText(delta: number | null, unit: string) {
        if (delta === null) return '비교 데이터 없음';
        if (delta === 0) return '변동 없음';
        return (delta > 0 ? '▲ ' : '▼ ') + Math.abs(delta).toFixed(unit === '%p' || unit === '분' ? 1 : 0) + unit;
    }

    private buildTrend(records: any[], range: any) {
        const labels: string[] = [];
        const qaPass: Array<number | null> = [];
        const kgPass: Array<number | null> = [];
        const qaVolume: number[] = [];
        const kgVolume: number[] = [];
        const cumulativeQa: any[] = [];
        const cumulativeKg: any[] = [];
        const cursor = new Date(range.start);
        while (cursor.getTime() <= range.end.getTime()) {
            const dayStart = new Date(cursor);
            const dayEnd = this.endOfDay(cursor);
            const daily = records.filter((record: any) => record.submittedAt >= dayStart && record.submittedAt <= dayEnd);
            const qa = daily.filter((record: any) => record.kind === 'qa');
            const kg = daily.filter((record: any) => record.kind === 'kg');
            cumulativeQa.push(...qa);
            cumulativeKg.push(...kg);
            labels.push((cursor.getMonth() + 1) + '/' + cursor.getDate());
            qaPass.push(this.passRate(cumulativeQa));
            kgPass.push(this.passRate(cumulativeKg));
            qaVolume.push(qa.length);
            kgVolume.push(kg.length);
            cursor.setDate(cursor.getDate() + 1);
        }
        this.weekLabels = labels;
        this.qaPass = qaPass;
        this.kgPass = kgPass;
        this.qaVolume = qaVolume;
        this.kgVolume = kgVolume;
        this.hasTrendData = records.length > 0;
    }

    private buildRisks(records: any[]) {
        const counts: any = {};
        records.forEach((record: any) => record.issues.forEach((issue: string) => counts[issue] = (counts[issue] || 0) + 1));
        this.riskFactors = Object.keys(this.issueMeta).map((code: string) => ({
            code: code,
            label: this.issueMeta[code].label,
            color: this.issueMeta[code].color,
            value: counts[code] || 0
        })).filter((factor: any) => factor.value > 0).sort((a: any, b: any) => b.value - a.value);
        this.hasRiskData = this.riskTotal() > 0;
    }

    private buildProjects(records: any[]) {
        const grouped: any = {};
        records.forEach((record: any) => {
            if (!grouped[record.projectId]) grouped[record.projectId] = { id: record.projectId, name: record.projectName, qaRows: [], kgRows: [], issues: [] };
            grouped[record.projectId][record.kind + 'Rows'].push(record);
            grouped[record.projectId].issues.push(...record.issues);
        });
        const stateProjects = Array.isArray(this.workspaceState.projects)
            ? this.workspaceState.projects : [];
        const stateTasks = Array.isArray(this.workspaceState.tasks)
            ? this.workspaceState.tasks : [];
        const evaluations = this.workspaceState.evaluations
            && typeof this.workspaceState.evaluations === 'object'
            ? this.workspaceState.evaluations : {};
        const projectRows = stateProjects.length ? stateProjects : Object.keys(grouped).map(
            (id: string) => ({ id: id, name: grouped[id].name })
        );
        const allProjects = projectRows.map((stateProject: any) => {
            const id = String(stateProject.id || stateProject.projectId || stateProject.project_id || '');
            const selected = grouped[id] || {
                id: id,
                name: String(stateProject.name || stateProject.title || id),
                qaRows: [], kgRows: [], issues: []
            };
            const issueCounts: any = {};
            selected.issues.forEach((issue: string) => issueCounts[issue] = (issueCounts[issue] || 0) + 1);
            const topIssues = Object.keys(issueCounts).sort(
                (a: string, b: string) => issueCounts[b] - issueCounts[a]
            ).slice(0, 2);
            const projectTasks = stateTasks.filter((task: any) =>
                String(task.projectId || task.project_id || '') === id
            );
            const reviewDone = projectTasks.filter((task: any) =>
                evaluations[String(task.id || '')]?.decision === 'approve'
            ).length;
            const fallbackScore = this.optionalNumber(
                stateProject.ai_quality_score ?? stateProject.combined_score
            );
            const qaRate = this.passRate(selected.qaRows);
            const kgRate = this.passRate(selected.kgRows);
            const dataSummary = Number(stateProject.qa_count || 0).toLocaleString()
                + ' QA · ' + Number(stateProject.node_count || 0).toLocaleString()
                + ' nodes · ' + Number(stateProject.edge_count || 0).toLocaleString()
                + ' relations';
            return {
                id: id,
                name: String(stateProject.name || stateProject.title || selected.name || id),
                qa: qaRate === null ? fallbackScore : qaRate,
                kg: kgRate === null ? fallbackScore : kgRate,
                risks: selected.issues.length,
                reviewDone: reviewDone,
                reviewTotal: projectTasks.length,
                change: null,
                issue: topIssues.length
                    ? topIssues.map((code: string) => this.issueMeta[code]?.label || code).join(', ')
                    : dataSummary
            };
        });
        this.projectTotal = allProjects.length;
        this.projects = allProjects
            .sort((a: any, b: any) => b.risks - a.risks || a.name.localeCompare(b.name))
            .slice(0, 5);
    }

    private buildActivities(records: any[]) {
        this.activities = records.slice().sort((a: any, b: any) => b.submittedAt.getTime() - a.submittedAt.getTime()).slice(0, 5).map((record: any) => ({
            title: record.kind.toUpperCase() + (
                record.delegatedAi ? ' AI 품질 검수 제출' : ' 검수 제출'
            ),
            description: record.projectName
                + (record.issues.length ? ' · 위험 요인 ' + record.issues.length + '건' : '')
                + (
                    record.delegatedAi && record.humanReleaseStatus === 'pending'
                        ? ' · 사람 release 대기' : ''
                ),
            time: this.relativeTime(record.submittedAt),
            tone: record.kind === 'qa' ? 'green' : 'purple',
            icon: 'fa-circle-check',
            route: '/review-results/' + record.kind + '/' + record.taskId
        }));
    }

    private relativeTime(date: Date) {
        const minutes = Math.max(0, Math.floor((Date.now() - date.getTime()) / 60000));
        if (minutes < 1) return '방금 전';
        if (minutes < 60) return minutes + '분 전';
        if (minutes < 1440) return Math.floor(minutes / 60) + '시간 전';
        return Math.floor(minutes / 1440) + '일 전';
    }

    private scheduleCharts() {
        if (typeof window === 'undefined') return;
        window.setTimeout(() => {
            this.drawTrendChart();
            this.drawRiskChart();
        }, 0);
    }

    private prepareCanvas(id: string, height: number) {
        if (typeof document === 'undefined') return null;
        const canvas = document.getElementById(id) as HTMLCanvasElement;
        if (!canvas) return null;
        const width = Math.max(canvas.parentElement?.clientWidth || 320, 280);
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        const context = canvas.getContext('2d');
        if (!context) return null;
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        return { canvas, context, width, height };
    }

    private drawTrendChart() {
        const prepared = this.prepareCanvas('qualityTrendCanvas', 300);
        if (!prepared) return;
        const { context: ctx, width, height } = prepared;
        const padding = { top: 40, right: 28, bottom: 44, left: 50 };
        const chartWidth = width - padding.left - padding.right;
        const chartHeight = height - padding.top - padding.bottom;
        const showingPassRate = this.chartMode === '통과율';
        const passValues = [...this.qaPass, ...this.kgPass]
            .filter((value: number | null) => value !== null && value !== undefined) as number[];
        const passMin = passValues.some((value: number) => value < 70) ? 0 : 70;
        const largestVolume = Math.max(1, ...this.qaVolume, ...this.kgVolume);
        const volumeMax = Math.max(5, Math.ceil(largestVolume / 5) * 5);
        const passTicks = passMin === 0
            ? [0, 20, 40, 60, 80, 100]
            : [70, 75, 80, 85, 90, 95, 100];
        const volumeTicks = Array.from({ length: 6 }, (_: any, index: number) =>
            Math.round(volumeMax * index / 5)
        );
        const ticks = showingPassRate ? passTicks : volumeTicks;
        const axisMin = showingPassRate ? passMin : 0;
        const axisMax = showingPassRate ? 100 : volumeMax;
        const xAt = (index: number, length: number) =>
            padding.left + (chartWidth / Math.max(1, length - 1)) * index;
        const yAt = (value: number) => {
            const bounded = Math.max(axisMin, Math.min(axisMax, value));
            return padding.top + chartHeight - ((bounded - axisMin) / Math.max(1, axisMax - axisMin)) * chartHeight;
        };
        const chartBottom = padding.top + chartHeight;

        ctx.clearRect(0, 0, width, height);
        ctx.font = '11px sans-serif';
        ctx.lineWidth = 1;
        ticks.forEach((tick: number) => {
            const y = yAt(tick);
            ctx.strokeStyle = '#e7e9ec';
            ctx.beginPath();
            ctx.moveTo(padding.left, y);
            ctx.lineTo(width - padding.right, y);
            ctx.stroke();
            ctx.fillStyle = '#8a8d93';
            ctx.textAlign = 'right';
            ctx.fillText(String(tick), padding.left - 10, y + 4);
        });

        if (showingPassRate) {
            const targetY = yAt(90);
            ctx.strokeStyle = 'rgba(39, 146, 72, 0.38)';
            ctx.setLineDash([4, 5]);
            ctx.beginPath();
            ctx.moveTo(padding.left, targetY);
            ctx.lineTo(width - padding.right, targetY);
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.fillStyle = '#4f8c61';
            ctx.font = '10px sans-serif';
            ctx.textAlign = 'right';
            ctx.fillText('목표 90%', width - padding.right, targetY - 6);
        }

        ctx.fillStyle = '#777b82';
        ctx.font = '11px sans-serif';
        ctx.textAlign = 'left';
        ctx.fillText(showingPassRate ? '누적 통과율(%)' : '일별 처리량(건)', padding.left, 16);

        this.weekLabels.forEach((label: string, index: number) => {
            const x = xAt(index, this.weekLabels.length);
            ctx.fillStyle = '#74777d';
            ctx.textAlign = 'center';
            ctx.fillText(label, x, height - 14);
        });

        const drawPassSeries = (
            values: Array<number | null>,
            color: string,
            labelOffsetY: number
        ) => {
            const points = values.map((value: number | null, index: number) => {
                if (value === null || value === undefined) return null;
                return { value, index, x: xAt(index, values.length), y: yAt(value) };
            }).filter((point: any) => point !== null) as any[];
            if (!points.length) return;

            ctx.save();
            ctx.beginPath();
            ctx.rect(padding.left, padding.top, chartWidth, chartHeight);
            ctx.clip();
            ctx.strokeStyle = color;
            ctx.lineWidth = 2.6;
            ctx.lineJoin = 'round';
            ctx.lineCap = 'round';
            ctx.beginPath();
            ctx.moveTo(points[0].x, points[0].y);
            points.slice(1).forEach((point: any) => ctx.lineTo(point.x, point.y));
            ctx.stroke();
            ctx.restore();

            points.forEach((point: any, pointIndex: number) => {
                ctx.fillStyle = '#ffffff';
                ctx.beginPath();
                ctx.arc(point.x, point.y, 4.8, 0, Math.PI * 2);
                ctx.fill();
                ctx.fillStyle = color;
                ctx.beginPath();
                ctx.arc(point.x, point.y, 3.1, 0, Math.PI * 2);
                ctx.fill();

                const previous = pointIndex > 0 ? points[pointIndex - 1] : null;
                const isLast = pointIndex === points.length - 1;
                const valueChanged = !previous || previous.value !== point.value;
                if (!valueChanged && !isLast) return;

                let labelY = point.y + labelOffsetY;
                if (point.y < padding.top + 22) labelY = point.y + (labelOffsetY < 0 ? 19 : 32);
                if (point.y > chartBottom - 22) labelY = point.y - (labelOffsetY < 0 ? 18 : 30);
                ctx.fillStyle = color;
                ctx.font = '600 10px sans-serif';
                ctx.textAlign = 'center';
                ctx.fillText(point.value.toFixed(1) + '%', point.x, labelY);
            });
        };

        const drawVolumeBars = () => {
            const interval = chartWidth / Math.max(1, this.weekLabels.length - 1);
            const barWidth = Math.max(7, Math.min(14, interval * 0.15));
            this.weekLabels.forEach((_: string, index: number) => {
                const qa = this.qaVolume[index] || 0;
                const kg = this.kgVolume[index] || 0;
                const center = xAt(index, this.weekLabels.length);
                [
                    { value: qa, color: '#65ad7a', x: center - barWidth / 2 - 2 },
                    { value: kg, color: '#927bd0', x: center + barWidth / 2 + 2 }
                ].forEach((bar: any) => {
                    if (bar.value <= 0) return;
                    const y = yAt(bar.value);
                    ctx.fillStyle = bar.color;
                    ctx.globalAlpha = 0.78;
                    ctx.fillRect(bar.x - barWidth / 2, y, barWidth, chartBottom - y);
                    ctx.globalAlpha = 1;
                    ctx.fillStyle = bar.color;
                    ctx.font = '600 10px sans-serif';
                    ctx.textAlign = 'center';
                    ctx.fillText(String(bar.value), bar.x, Math.max(padding.top + 10, y - 6));
                });
            });
        };

        if (showingPassRate) {
            drawPassSeries(this.qaPass, '#279248', -13);
            drawPassSeries(this.kgPass, '#6f4db4', 18);
        } else {
            drawVolumeBars();
        }
    }

    private drawRiskChart() {
        if (!this.hasRiskData) return;
        const prepared = this.prepareSquareCanvas('riskDonutCanvas', 220);
        if (!prepared) return;
        const { context: ctx, width, height } = prepared;
        const centerX = width / 2;
        const centerY = height / 2;
        const radius = Math.min(width, height) * 0.38;
        const lineWidth = Math.max(28, radius * 0.42);
        const total = this.riskTotal();
        let start = -Math.PI / 2;

        ctx.clearRect(0, 0, width, height);
        this.riskFactors.forEach((factor: any) => {
            const angle = (factor.value / total) * Math.PI * 2;
            ctx.beginPath();
            ctx.strokeStyle = factor.color;
            ctx.lineWidth = lineWidth;
            ctx.arc(centerX, centerY, radius - lineWidth / 2, start + 0.015, start + angle - 0.015);
            ctx.stroke();
            start += angle;
        });
    }

    private prepareSquareCanvas(id: string, maxSize: number) {
        if (typeof document === 'undefined') return null;
        const canvas = document.getElementById(id) as HTMLCanvasElement;
        if (!canvas) return null;
        const available = canvas.parentElement?.clientWidth || maxSize;
        const size = Math.max(150, Math.min(maxSize, available));
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(size * ratio);
        canvas.height = Math.round(size * ratio);
        canvas.style.width = size + 'px';
        canvas.style.height = size + 'px';
        const context = canvas.getContext('2d');
        if (!context) return null;
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        return { canvas, context, width: size, height: size };
    }
}

export default PageDashboardComponent;